/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { BackendApiAccessInvitationsService } from './services/backend-api-access-invitations.service';
import { BackendApiAccessMembersService } from './services/backend-api-access-members.service';
import { BackendApiAccessOwnershipService } from './services/backend-api-access-ownership.service';
import { BackendApiAccessRolePresetsService } from './services/backend-api-access-role-presets.service';
import { BackendApiAuthService } from './services/backend-api-auth.service';
import { BackendApiAccountService } from './services/backend-api-account.service';
import { BackendApiProfileService } from './services/backend-api-profile.service';
import { BackendApiCapexsService } from './services/backend-api-capexs.service';
import { BackendApiFeedbackService } from './services/backend-api-feedback.service';
import { BackendApiCreditsService } from './services/backend-api-credits.service';
import { BackendApiLeasingsService } from './services/backend-api-leasings.service';
import { BackendApiOwnFundsService } from './services/backend-api-own-funds.service';
import { BackendApiWorkingCapitalsService } from './services/backend-api-working-capitals.service';
import { BackendApiHandbookService } from './services/backend-api-handbook.service';
import { BackendApiHelpersService } from './services/backend-api-helpers.service';
import { BackendApiTranslationService } from './services/backend-api-translation.service';
import { BackendApiMlService } from './services/backend-api-ml.service';
import { BackendApiMonitoringActualsService } from './services/backend-api-monitoring-actuals.service';
import { BackendApiMonitoringActualOpexesService } from './services/backend-api-monitoring-actual-opexes.service';
import { BackendApiMonitoringHelpersService } from './services/backend-api-monitoring-helpers.service';
import { BackendApiMonitoringEnumsService } from './services/backend-api-monitoring-enums.service';
import { BackendApiMonitoringComparisonsService } from './services/backend-api-monitoring-comparisons.service';
import { BackendApiMonitoringFactReportsService } from './services/backend-api-monitoring-fact-reports.service';
import { BackendApiMonitoringPlanService } from './services/backend-api-monitoring-plan.service';
import { BackendApiMonitoringScenarioDataService } from './services/backend-api-monitoring-scenario-data.service';
import { BackendApiOpexsMaterialsService } from './services/backend-api-opexs-materials.service';
import { BackendApiOpexsOtherService } from './services/backend-api-opexs-other.service';
import { BackendApiOpexsProductsService } from './services/backend-api-opexs-products.service';
import { BackendApiOpexsRentService } from './services/backend-api-opexs-rent.service';
import { BackendApiOpexsSalaryService } from './services/backend-api-opexs-salary.service';
import { BackendApiOpexsVariantsService } from './services/backend-api-opexs-variants.service';
import { BackendApiCalcResultsService } from './services/backend-api-calc-results.service';
import { BackendApiExcelExportService } from './services/backend-api-excel-export.service';
import { BackendApiScenariosService } from './services/backend-api-scenarios.service';
import { BackendApiDiscountRateService } from './services/backend-api-discount-rate.service';
import { BackendApiDiscountRateCopyService } from './services/backend-api-discount-rate-copy.service';
import { BackendApiTaxesMinService } from './services/backend-api-taxes-min.service';
import { BackendApiTaxesService } from './services/backend-api-taxes.service';
import { BackendApiTaxesCopyService } from './services/backend-api-taxes-copy.service';
import { BackendApiTaxesEnumsService } from './services/backend-api-taxes-enums.service';
import { BackendApiTaxesSpecialService } from './services/backend-api-taxes-special.service';
import { BackendApiTaxesStandardService } from './services/backend-api-taxes-standard.service';
import { BackendApiProjectsOtherService } from './services/backend-api-projects-other.service';
import { BackendApiProjectsSectorsService } from './services/backend-api-projects-sectors.service';
import { BackendApiProjectsConfigService } from './services/backend-api-projects-config.service';
import { BackendApiProjectsExchangeService } from './services/backend-api-projects-exchange.service';
import { BackendApiProjectsFilesService } from './services/backend-api-projects-files.service';
import { BackendApiProjectsService } from './services/backend-api-projects.service';
import { BackendApiProductsService } from './services/backend-api-products.service';
import { BackendApiOpexsService } from './services/backend-api-opexs.service';
import { BackendApiSalesService } from './services/backend-api-sales.service';
import { BackendApiSubscriptionService } from './services/backend-api-subscription.service';
import { BackendApiSupportService } from './services/backend-api-support.service';
import { BackendApiBusinessAngelService } from './services/backend-api-business-angel.service';
import { BackendApiVentureFundDividendsService } from './services/backend-api-venture-fund-dividends.service';
import { BackendApiVentureFundLoansService } from './services/backend-api-venture-fund-loans.service';
import { BackendApiVentureFundVariantsService } from './services/backend-api-venture-fund-variants.service';
import { BackendApiVentureFundService } from './services/backend-api-venture-fund.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    BackendApiAccessInvitationsService,
    BackendApiAccessMembersService,
    BackendApiAccessOwnershipService,
    BackendApiAccessRolePresetsService,
    BackendApiAuthService,
    BackendApiAccountService,
    BackendApiProfileService,
    BackendApiCapexsService,
    BackendApiFeedbackService,
    BackendApiCreditsService,
    BackendApiLeasingsService,
    BackendApiOwnFundsService,
    BackendApiWorkingCapitalsService,
    BackendApiHandbookService,
    BackendApiHelpersService,
    BackendApiTranslationService,
    BackendApiMlService,
    BackendApiMonitoringActualsService,
    BackendApiMonitoringActualOpexesService,
    BackendApiMonitoringHelpersService,
    BackendApiMonitoringEnumsService,
    BackendApiMonitoringComparisonsService,
    BackendApiMonitoringFactReportsService,
    BackendApiMonitoringPlanService,
    BackendApiMonitoringScenarioDataService,
    BackendApiOpexsMaterialsService,
    BackendApiOpexsOtherService,
    BackendApiOpexsProductsService,
    BackendApiOpexsRentService,
    BackendApiOpexsSalaryService,
    BackendApiOpexsVariantsService,
    BackendApiCalcResultsService,
    BackendApiExcelExportService,
    BackendApiScenariosService,
    BackendApiDiscountRateService,
    BackendApiDiscountRateCopyService,
    BackendApiTaxesMinService,
    BackendApiTaxesService,
    BackendApiTaxesCopyService,
    BackendApiTaxesEnumsService,
    BackendApiTaxesSpecialService,
    BackendApiTaxesStandardService,
    BackendApiProjectsOtherService,
    BackendApiProjectsSectorsService,
    BackendApiProjectsConfigService,
    BackendApiProjectsExchangeService,
    BackendApiProjectsFilesService,
    BackendApiProjectsService,
    BackendApiProductsService,
    BackendApiOpexsService,
    BackendApiSalesService,
    BackendApiSubscriptionService,
    BackendApiSupportService,
    BackendApiBusinessAngelService,
    BackendApiVentureFundDividendsService,
    BackendApiVentureFundLoansService,
    BackendApiVentureFundVariantsService,
    BackendApiVentureFundService,
    ApiConfiguration,
  ],
})
export class BackendApiMetadoorModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<BackendApiMetadoorModule> {
    return {
      ngModule: BackendApiMetadoorModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: BackendApiMetadoorModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('BackendApiMetadoorModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }
  }
}
